import { palette } from '@livable/saas-react-components';
const MuiToggleButton = {
  styleOverrides: {
    root: {
      fontFamily: palette.fontFamilies.poppins,
      fontWeight: 600,
      padding: '13px 20px',
      fontSize: '15px',
      lineHeight: '20px',
      borderColor: palette.primary.main,
      backgroundColor: palette.shades[100],
      color: palette.primary.main,
      textTransform: 'none',
      whiteSpace: 'nowrap',
      transition: "background-color ".concat(palette.transitions.short),
      '&.Mui-selected': {
        backgroundColor: palette.primary.main,
        color: palette.common.white,
        '&:hover': {
          backgroundColor: palette.primary.main
        },
        '&.Mui-disabled': {
          backgroundColor: '#7ebdc2',
          color: palette.common.white
        }
      },
      '&.Mui-disabled': {
        borderColor: palette.primary.main,
        backgroundColor: palette.shades[200],
        color: palette.shades[400],
        pointerEvents: 'initial',
        cursor: 'not-allowed',
        '&:hover': {
          backgroundColor: palette.shades[200]
        }
      },
      '&:hover': {
        backgroundColor: palette.shades[300]
      }
    },
    sizeSmall: {
      fontSize: '13px',
      lineHeight: '16px',
      padding: '9px 16px'
    }
  }
};
export default MuiToggleButton;